import type { MessageType } from '~/types/code/code';

/**
 * メッセージのフォールバック定義
 * APIからメッセージが取得できない場合に使用される
 */
export const MESSAGE_FALLBACK: Record<string, MessageFallbackInfo> = {
  60001: {
    messageCd: '60001',
    messageType: '1',
    messageContent: '位置情報サービスが利用できません。',
  },
  60002: {
    messageCd: '60002',
    messageType: '1',
    messageContent: '支社が選択されていません。',
  },
  60003: {
    messageCd: '60003',
    messageType: '1',
    messageContent: '駅が選択されていません。',
  },
  60004: {
    messageCd: '60004',
    messageType: '1',
    messageContent: 'トラックまたはヘッドが選択されていません。',
  },
  60005: {
    messageCd: '60005',
    messageType: '1',
    messageContent: 'シャーシが選択されていません。',
  },
  60006: {
    messageCd: '60006',
    messageType: '1',
    messageContent: 'トラックコンテナ積載個数が選択されていません。',
  },
  60007: {
    messageCd: '60007',
    messageType: '1',
    messageContent: '車番が選択されていません。',
  },
  60008: {
    messageCd: '60008',
    messageType: '1',
    messageContent: '伝票番号を入力してください。',
  },
  60009: {
    messageCd: '60009',
    messageType: '1',
    messageContent: '伝票番号は9桁または13桁または20桁で入力してください。',
  },
  60010: {
    messageCd: '60010',
    messageType: '1',
    messageContent: '既に読込済みの伝票番号です。',
  },
  60011: {
    messageCd: '60011',
    messageType: '1',
    messageContent: '作業の内容が変更されています。画面と伝票を確認してください。',
  },
  60012: {
    messageCd: '60012',
    messageType: '1',
    messageContent: 'ウイング車代行の伝票は読み込みできません。',
  },
  60013: {
    messageCd: '60013',
    messageType: '1',
    messageContent: '作業を開始する伝票が選択されていません。',
  },
  60014: {
    messageCd: '60014',
    messageType: '1',
    messageContent: 'アラートメッセージが確認済みとなっていない作業があります。',
  },
  60015: {
    messageCd: '60015',
    messageType: '1',
    messageContent: '開始する代行利用者を選択してください。',
  },
  60016: {
    messageCd: '60016',
    messageType: '1',
    messageContent: '同時に１００件以上報告することはできません。報告件数を９９件以下にしてください。',
  },
  60017: {
    messageCd: '60017',
    messageType: '1',
    messageContent: 'トラックを選択してください。',
  },
  60018: {
    messageCd: '60018',
    messageType: '1',
    messageContent: '作業の報告を行ってから作業完了ボタンを押してください。',
  },
  60019: {
    messageCd: '60019',
    messageType: '3',
    messageContent: '報告を行っていない作業があります。よろしいですか？',
  },
  60020: {
    messageCd: '60020',
    messageType: '1',
    messageContent: '同じコンテナにまだ報告していない作業があります。確認してください。',
  },
  60021: {
    messageCd: '60021',
    messageType: '1',
    messageContent: '報告するコンテナが不一致です。確認してください。',
  },
  60022: {
    messageCd: '60022',
    messageType: '1',
    messageContent: '同じ原票番号の作業を異なるコンテナ番号で報告できません。',
  },
  60023: {
    messageCd: '60023',
    messageType: '1',
    messageContent: '同じ原票番号の作業を異なるコンテナ所在で報告できません。',
  },
  60024: {
    messageCd: '60024',
    messageType: '1',
    messageContent: '同じ原票番号の作業を異なる封印環番号で報告できません。',
  },
  60025: {
    messageCd: '60025',
    messageType: '1',
    messageContent: 'アラートメッセージが確認済みとなっていません。',
  },
  60026: {
    messageCd: '60026',
    messageType: '1',
    messageContent: '代行利用者が選択されていません。',
  },
  60027: {
    messageCd: '60027',
    messageType: '1',
    messageContent: '同じコンテナ番号の作業を異なるコンテナ所在で報告できません。',
  },
  60028: {
    messageCd: '60028',
    messageType: '1',
    messageContent: 'コンテナ番号を入力してください。',
  },
  60029: {
    messageCd: '60029',
    messageType: '3',
    messageContent: '伝票の読込が完了しました。',
  },
  60030: {
    messageCd: '60030',
    messageType: '3',
    messageContent: 'この伝票を画面から削除しますか？',
  },
  60031: {
    messageCd: '60031',
    messageType: '1',
    messageContent: '作業を完了する伝票が選択されていません。',
  },
  60032: {
    messageCd: '60032',
    messageType: '3',
    messageContent: '作業報告を取り消しますか？',
  },
  60033: {
    messageCd: '60033',
    messageType: '1',
    messageContent: '完了する代行利用者を選択してください。',
  },
  60034: {
    messageCd: '60034',
    messageType: '1',
    messageContent: 'ライトが使用できません。',
  },
  60035: {
    messageCd: '60035',
    messageType: '1',
    messageContent: '通信に失敗しました。\n時間をおいて再度お試しください。',
  },
  60036: {
    messageCd: '60036',
    messageType: '1',
    messageContent: '作業駅が設定されていません。',
  },
  60037: {
    messageCd: '60037',
    messageType: '1',
    messageContent: '日付が選択されていません。',
  },
  60038: {
    messageCd: '60038',
    messageType: '1',
    messageContent: 'カメラが使用できません。',
  },
  60039: {
    messageCd: '60039',
    messageType: '1',
    messageContent: 'このQRコードは無効です。',
  },
  60040: {
    messageCd: '60040',
    messageType: '1',
    messageContent: '最寄り駅が見つかりませんでした。',
  },
  60041: {
    messageCd: '60041',
    messageType: '3',
    messageContent: 'ログアウトしますか？',
  },
  60042: {
    messageCd: '60042',
    messageType: '1',
    messageContent: '入力した伝票番号に誤りがあります。',
  },
  60043: {
    messageCd: '60043',
    messageType: '1',
    messageContent: '伝票番号は13桁または20桁で入力してください。',
  },
  60044: {
    messageCd: '60044',
    messageType: '1',
    messageContent: '封印環番号は半角で入力してください。',
  },
  60045: {
    messageCd: '60045',
    messageType: '1',
    messageContent: '封印環番号に入力できない記号が含まれています。',
  },
  60046: {
    messageCd: '60046',
    messageType: '3',
    messageContent: '一覧をタップすることで、見込情報を表示できます。',
  },
  60047: {
    messageCd: '60047',
    messageType: '3',
    messageContent: 'お使いのQRコードはまもなくご利用いただけなくなります。大変お手数ですが、駅フロントの社員へお声がけいただき、新しいQRコードの発行をご依頼ください。',
  },
  60048: {
    messageCd: '60048',
    messageType: '3',
    messageContent: '代理ログインを終了しますか？',
  },
  60049: {
    messageCd: '60049',
    messageType: '1',
    messageContent: '現在のパスワードと新しいパスワードは異なる値を入力してください。',
  },
  60050: {
    messageCd: '60050',
    messageType: '1',
    messageContent: '新しいパスワードは8文字以上16文字以下かつ、英大文字、英小文字、数字、記号をすべて含めてください。',
  },
  60051: {
    messageCd: '60051',
    messageType: '1',
    messageContent: '新しいパスワードと確認用のパスワードが一致しません。',
  },
  60052: {
    messageCd: '60052',
    messageType: '1',
    messageContent: '無効なアカウント区分が選択されました。',
  },
  60053: {
    messageCd: '60053',
    messageType: '1',
    messageContent: 'コンテナ番号が重複しています。',
  },
  60054: {
    messageCd: '60054',
    messageType: '1',
    messageContent: '$1はカタカナで入力してください。',
  },
  60055: {
    messageCd: '60055',
    messageType: '1',
    messageContent: '$1は半角数字で入力してください。',
  },
  60056: {
    messageCd: '60056',
    messageType: '1',
    messageContent: '$1は半角英数記号で入力してください。',
  },
  60057: {
    messageCd: '60057',
    messageType: '1',
    messageContent: '所属情報を1件以上設定してください。',
  },
  60058: {
    messageCd: '60058',
    messageType: '1',
    messageContent: '$1は半角英数字で入力してください。',
  },
  60059: {
    messageCd: '60059',
    messageType: '4',
    messageContent: '申請を行いました。登録完了するまでしばらくお待ちください。',
  },
  60060: {
    messageCd: '60060',
    messageType: '1',
    messageContent: '選択した所属情報は既に設定済みです。',
  },
  60061: {
    messageCd: '60061',
    messageType: '3',
    messageContent: '申請を却下しますか？',
  },
  60062: {
    messageCd: '60062',
    messageType: '4',
    messageContent: '申請を却下しました。',
  },
  60063: {
    messageCd: '60063',
    messageType: '1',
    messageContent: '有効な利用者を設定してください。',
  },
  60064: {
    messageCd: '60064',
    messageType: '1',
    messageContent: '有効な集配人を設定してください。',
  },
  60065: {
    messageCd: '60065',
    messageType: '4',
    messageContent: '承認が完了しました。',
  },
  60066: {
    messageCd: '60066',
    messageType: '3',
    messageContent: 'アカウントを削除しますか？',
  },
  60067: {
    messageCd: '60067',
    messageType: '4',
    messageContent: 'アカウントを削除しました。',
  },
  60068: {
    messageCd: '60068',
    messageType: '3',
    messageContent: 'パスワードを初期化しますか？',
  },
  60069: {
    messageCd: '60069',
    messageType: '4',
    messageContent: 'パスワードを初期化しました。',
  },
  60070: {
    messageCd: '60070',
    messageType: '4',
    messageContent: '編集内容を保存しました。',
  },
  60071: {
    messageCd: '60071',
    messageType: '3',
    messageContent: 'ユーザ情報変更申請を取り消しますか？',
  },
  60072: {
    messageCd: '60072',
    messageType: '4',
    messageContent: 'ユーザ情報変更申請を取り消しました。',
  },
  60073: {
    messageCd: '60073',
    messageType: '1',
    messageContent: 'ユーザ情報変更申請の取消に失敗しました。お手数ですが再度やり直してください。',
  },
  60074: {
    messageCd: '60074',
    messageType: '3',
    messageContent: '新しいQRコードを発行しますか？発行すると、以前に発行済みのQRコードは無効化され、使用できなくなります。',
  },
  60075: {
    messageCd: '60075',
    messageType: '1',
    messageContent: 'すでに申請中のため新しい申請は行えません。',
  },
  60076: {
    messageCd: '60076',
    messageType: '1',
    messageContent: '所属情報$1: 有効な利用者を設定してください。',
  },
  60077: {
    messageCd: '60077',
    messageType: '1',
    messageContent: '所属情報$1: 有効な集配人を設定してください。',
  },
  60078: {
    messageCd: '60078',
    messageType: '4',
    messageContent: '権限を変更しました。',
  },
  60079: {
    messageCd: '60079',
    messageType: '3',
    messageContent: 'ロックを解除しますか？',
  },
  60080: {
    messageCd: '60080',
    messageType: '4',
    messageContent: 'ロックを解除しました。',
  },
  60081: {
    messageCd: '60081',
    messageType: '3',
    messageContent: '【注意】緊締装置の「解錠」忘れにご注意！',
  },
  60082: {
    messageCd: '60082',
    messageType: '1',
    messageContent: '$1は全角文字で入力してください。',
  },
  60083: {
    messageCd: '60083',
    messageType: '4',
    messageContent: 'パスワードを変更しました。',
  },
  60084: {
    messageCd: '60084',
    messageType: '1',
    messageContent: '$1に記号は使用できません。',
  },
  60085: {
    messageCd: '60085',
    messageType: '3',
    messageContent: 'アカウントをロックしますか？',
  },
  60086: {
    messageCd: '60086',
    messageType: '4',
    messageContent: 'アカウントをロックしました。',
  },
  60087: {
    messageCd: '60087',
    messageType: '3',
    messageContent: '【注意】緊締装置の「施錠」忘れにご注意！',
  },
  60088: {
    messageCd: '60088',
    messageType: '3',
    messageContent: '【注意】緊締装置の「施錠・解錠」忘れにご注意！',
  },
  60089: {
    messageCd: '60089',
    messageType: '1',
    messageContent: '$1はメールアドレスの形式で入力してください。',
  },
  60090: {
    messageCd: '60090',
    messageType: '1',
    messageContent: '$1は$2桁で入力してください。',
  },
  60091: {
    messageCd: '60091',
    messageType: '1',
    messageContent: 'システムエラーが発生しました。お手数ですが、再度お試しください。問題が解消しない場合は、サポートまでお問い合わせください。',
  },
  60092: {
    messageCd: '60092',
    messageType: '3',
    messageContent: 'この申請は既に操作されています。承認一覧画面に戻ります。',
  },
  60093: {
    messageCd: '60093',
    messageType: '1',
    messageContent: '位置情報が取得できません。',
  },
  60094: {
    messageCd: '60094',
    messageType: '1',
    messageContent: '位置情報が取得できません。GPSをONにしてください。',
  },
  60095: {
    messageCd: '60095',
    messageType: '1',
    messageContent: '安全のため、移動中は操作できません。',
  },
  61001: {
    messageCd: '61001',
    messageType: '1',
    messageContent: '$1は入力必須です。',
  },
  69999: {
    messageCd: '69999',
    messageType: '1',
    messageContent: '予期せぬエラーが発生しました。',
  },
} as const;

type MessageFallbackInfo = {
  messageCd: string;
  messageType: MessageType;
  messageContent: string;
};
